import api from '../Api';

export const getWorkers = () => async dispatch => {
  const { data } = await api.get('/workers');
  dispatch({
    type: 'FETCH_WORKERS',
    payload: data,
  });
};

export const clearWorkers = () => ({
  type: 'CLEAR_WORKERS',
});

export const getWorker = id => async dispatch => {
  const { data } = await api.get(`/workers/${id}`);
  dispatch({
    type: 'FETCH_WORKER',
    payload: data,
  });
};

export const clearWorker = () => ({
  type: 'CLEAR_WORKER',
});

export const getWorkerIds = () => async dispatch => {
  const { data } = await api.get(`/workers/ids`);

  dispatch({
    type: 'FETCH_WORKER_IDS',
    payload: data,
  });
};

export const clearWorkerIds = () => ({
  type: 'CLEAR_WORKER_IDS',
});

export const getWorkerJobs = () => async dispatch => {
  const { data } = await api.get('/worker-jobs');
  dispatch({
    type: 'FETCH_WORKER_JOBS',
    payload: data,
  });
};

export const clearWorkerJobs = () => ({
  type: 'CLEAR_WORKER_JOBS',
});

export const getWorkerJob = id => async dispatch => {
  const { data } = await api.get(`/worker-jobs/${id}`);
  dispatch({
    type: 'FETCH_WORKER_JOB',
    payload: data,
  });
};

export const clearWorkerJob = () => ({
  type: 'CLEAR_WORKER_JOB',
});

export const getWorkerIssues = () => async dispatch => {
  const { data } = await api.get('/worker-jobs/issues');
  dispatch({
    type: 'FETCH_WORKER_ISSUES',
    payload: data,
  });
};

export const clearWorkerIssues = () => ({
  type: 'CLEAR_WORKER_ISSUES',
});

export const getWorkerIssue = id => async dispatch => {
  const { data } = await api.get(`/worker-jobs/issues/${id}`);
  dispatch({
    type: 'FETCH_WORKER_ISSUE',
    payload: data,
  });
};

export const clearWorkerIssue = () => ({
  type: 'CLEAR_WORKER_ISSUE',
});
